import { initModules } from "utils";

import Search from "./modules/search/search";

initModules({ Search });
